<s1-input-select [control]="control" [itemsList]="stati" [label]="'tasks.fields.stato'" [readonly]="readonly"></s1-input-select>